export default function isVideo(mediaSrc) {
  if (!mediaSrc) return false
  // remove possible parameters form the URL, and test against extensions
  return !!mediaSrc.replace(/\?.*$/, '').match(/\.(mp4|webm|avi|wmv|webvtt)$/i)
}
